/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menucandidateprofile2Inputs */

const en_menucandidateprofile2 = /** @type {(inputs: Menucandidateprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`My Profile`)
};

const de_menucandidateprofile2 = /** @type {(inputs: Menucandidateprofile2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mein Profil`)
};

/**
* | output |
* | --- |
* | "My Profile" |
*
* @param {Menucandidateprofile2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menucandidateprofile2 = /** @type {((inputs?: Menucandidateprofile2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menucandidateprofile2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_menucandidateprofile2(inputs)
	return en_menucandidateprofile2(inputs)
});
export { menucandidateprofile2 as "menuCandidateProfile" }